/* eslint-disable */
import libraries from "../arduino/libraries";

export default function init(Blockly, profile) {
  Blockly.Arduino.rtc = {};

  /**
   *
   *
   * @param {*} seconds
   * @param {*} minutes
   * @param {*} hours
   * @param {*} day
   * @param {*} year
   * @param {*} month
   * @return {*}
   */
  function setRTC(seconds, minutes, hours, day, month, year) {
    return ('rtc.adjust(DateTime(' + year + "," + month + "," + day + ","  + hours + "," + minutes  + ","  + seconds + '));\n');
  }

  /**************************************************************************************************************/
  function setupRtc() {
    Blockly.Arduino.includes_.push(libraries.rtc);
    Blockly.Arduino.definitions_.define_rtc = '#include "RTClib.h"';

    Blockly.Arduino.definitions_.var_rtc = "RTC_DS3231 rtc;\n";
    Blockly.Arduino.setups_.setup_rtc = "// RTC begin function\n" + "rtc.begin();\n";
  }
  /**************************************************************************************************************/
  Blockly.Arduino.rtc_set_time = function() {
    setupRtc();

    return setRTC(
      Blockly.Arduino.valueToCode(this, "SECOND", Blockly.Arduino.ORDER_ATOMIC) || "0",
      Blockly.Arduino.valueToCode(this, "MINUTE", Blockly.Arduino.ORDER_ATOMIC) || "0",
      Blockly.Arduino.valueToCode(this, "HOUR", Blockly.Arduino.ORDER_ATOMIC) || "0",
      Blockly.Arduino.valueToCode(this, "DAY", Blockly.Arduino.ORDER_ATOMIC) || "0",
      Blockly.Arduino.valueToCode(this, "MONTH", Blockly.Arduino.ORDER_ATOMIC) || "0",
      Blockly.Arduino.valueToCode(this, "YEAR", Blockly.Arduino.ORDER_ATOMIC) || "0"
    );
  };
  /**************************************************************************************************************/
  Blockly.Arduino.rtc_set = function() {
    setupRtc();
    const parameter = this.getFieldValue("FIELD");
    const value = Blockly.Arduino.valueToCode(this, "VALUE", Blockly.Arduino.ORDER_ATOMIC) || "0";

    if (parameter == "second") {
      return setRTC(value, " rtc.now().minute()", " rtc.now().hour()", " rtc.now().day()", " rtc.now().month()", " rtc.now().year()");
    } else if (parameter == "minute") {
      return setRTC("rtc.now().second()", value, " rtc.now().hour()", " rtc.now().day()", " rtc.now().month()", " rtc.now().year()");
    } else if (parameter == "hour") {
      return setRTC("rtc.now().second()", " rtc.now().minute()", value , " rtc.now().day()", " rtc.now().month()", " rtc.now().year()");
    } else if (parameter == "day") {
      return setRTC("rtc.now().second()", " rtc.now().minute()", " rtc.now().hour()", value, " rtc.now().month()", " rtc.now().year()");
    } else if (parameter == "month") {
      return setRTC("rtc.now().second()", " rtc.now().minute()", " rtc.now().hour()", " rtc.now().day()", value, " rtc.now().year()");
    } else if (parameter == "year") {
      return setRTC("rtc.now().second()", " rtc.now().minute()", " rtc.now().hour()", " rtc.now().day()", " rtc.now().month()", value);
    }
  };
  /**************************************************************************************************************/
  Blockly.Arduino.rtc_get = function() {
    setupRtc();
    let parameter = this.getFieldValue("FIELD");
    let code = "";

    "day" == parameter && (code = "rtc.now().day()");
    "month" == parameter && (code = "rtc.now().month()");
    "year" == parameter && (code = "(rtc.now().year())");
    "hour" == parameter && (code = "rtc.now().hour()");
    "minute" == parameter && (code = "rtc.now().minute()");
    "second" == parameter && (code = "rtc.now().second()");

    return [code, Blockly.Arduino.ORDER_ATOMIC];
  };
  /**************************************************************************************************************/
  Blockly.Arduino.rtc_get_time_text = function() {
    setupRtc();
    Blockly.Arduino.definitions_fnc_.rtc_time_text =
      "String rtc_time_text() {\n" +
      "char rtcbuffer[12];\n" +
      'sprintf(rtcbuffer,"%02u:%02u:%02u", rtc.now().hour(), rtc.now().minute(), rtc.now().second());\n' +
      "return String(rtcbuffer);\n" +
      "}\n";

    return ["rtc_time_text()", Blockly.Arduino.ORDER_ATOMIC];
  };
  /**************************************************************************************************************/
  Blockly.Arduino.rtc_get_date_text = function() {
    setupRtc();
    Blockly.Arduino.definitions_fnc_.rtc_date_text =
      '\nString rtc_date_text(){\n\tchar rtcbuffer[12];\n\tsprintf(rtcbuffer,"%02d/%02d/%04d", rtc.now().day(), rtc.now().month(), rtc.now().year());\n\treturn String(rtcbuffer);\n}\n';
    return ["rtc_date_text()", Blockly.Arduino.ORDER_ATOMIC];
  };

}